import { useMediaQuery } from 'react-responsive';

export const useXl = () =>
  useMediaQuery({
    minWidth: 1280,
  });
